import * as React from 'react';

const HappyFaceFilled16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.495 7.996c0-3.58-2.92-6.5-6.5-6.5s-6.5 2.92-6.5 6.5 2.92 6.5 6.5 6.5 6.5-2.92 6.5-6.5Zm-14.5 0c0-4.42 3.58-8 8-8s8 3.58 8 8-3.58 8-8 8-8-3.58-8-8Zm7.965 3.3c1.06 0 2.015-.477 2.625-1.327l.02-.027 1.285.804a4.806 4.806 0 0 1-3.93 2.05c-.7 0-1.4-.15-2.07-.47-.74-.36-1.34-.96-1.79-1.58l1.23-.804c.31.42.71.794 1.21 1.034.45.21.93.32 1.42.32Zm-2.765-6.1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm4.6 1c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1Z",
    clipRule: "evenodd"
  }
));
HappyFaceFilled16.Size = 16;
HappyFaceFilled16.Title = "HappyFaceFilled";

export { HappyFaceFilled16 as default };
